import { EstadoVerificacion } from '@/shared/model/enumerations/estado-verificacion';
import { EventoVerificacion, IEventoVerificacion } from '@/shared/model/seguimiento/evento-verificacion.model';
import resolveEstadoVerificacionVariant from '@/shared/estados/estados-verificacion.util';
import { DetalleVerificacion, IDetalleVerificacion } from '@/shared/model/seguimiento/verificacion/detalleVerificacion.model';

export interface IVerificacion {
  id?: string | null;
  cvuCoordinador?: string | null;
  clavePrograma?: string | null;
  mes?: number | null;
  anio?: number | null;
  estadoActual?: EstadoVerificacion | null;
  eventos?: EventoVerificacion[] | null;
  becarios?: IDetalleVerificacion[] | null;
  apoyos?: IDetalleVerificacion[] | null;
  variant?: string | null;
}

export class Verificacion implements IVerificacion {
  constructor(
    public id?: string | null,
    public cvuCoordinador?: string | null,
    public clavePrograma?: string | null,
    public mes?: number | null,
    public anio?: number | null,
    public estadoActual?: EstadoVerificacion | null,
    public eventos?: EventoVerificacion[] | null,
    public becarios?: DetalleVerificacion[] | null,
    public apoyos?: DetalleVerificacion[] | null,
    public variant?: string | null
  ) {}

  static fromObject(data: IVerificacion): Verificacion {
    const transformations = {
      eventos: (eventos: Array<IEventoVerificacion>) => eventos.map(EventoVerificacion.fromObject),
    };

    const verificacion = new Verificacion();
    for (const [key, value] of Object.entries(data)) {
      const transform = transformations[key as keyof IVerificacion];
      verificacion[key] = transform ? transform(value) : value;
    }

    verificacion.variant = resolveEstadoVerificacionVariant(verificacion.estadoActual);

    return verificacion;
  }
}

export interface PeriodoVerificacion {
  mes?: number | null;
  anio?: number | null;
  descripcion?: string | null;
}
